import { SnoozeSheet } from "./SnoozeSheet";
import {
  useLocationSnooze,
  useCreateLocationSnooze,
  useDeleteLocationSnooze,
} from "@/hooks/useSnooze";
import { toast } from "sonner";

type LocationSnoozeSheetWrapperProps = {
  locationId: number;
  locationName: string;
  isSnoozed: boolean;
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

export const LocationSnoozeSheetWrapper = ({
  locationId,
  locationName,
  isSnoozed,
  open,
  onOpenChange,
}: LocationSnoozeSheetWrapperProps) => {
  const { data: activeSnooze, isLoading: isSnoozeLoading } = useLocationSnooze(locationId, isSnoozed);
  const createSnooze = useCreateLocationSnooze();
  const deleteSnooze = useDeleteLocationSnooze();

  // Don't open the sheet until snooze data is loaded for snoozed items
  // so the manage step shows immediately instead of flashing the duration step
  const effectiveOpen = open && (!isSnoozed || !isSnoozeLoading);

  const handleSnooze = (end: string | null, reason: string | null) => {
    createSnooze.mutate(
      { locationId, end, reason },
      {
        onSuccess: () => {
          onOpenChange(false);
          toast.success("Location snoozed");
        },
        onError: () => toast.error("Failed to snooze location"),
      }
    );
  };

  const handleLift = () => {
    if (!activeSnooze) return;
    deleteSnooze.mutate(
      { locationId, snoozeId: activeSnooze.id },
      {
        onSuccess: () => {
          onOpenChange(false);
          toast.success("Location snooze lifted");
        },
        onError: () => toast.error("Failed to lift snooze"),
      }
    );
  };

  return (
    <SnoozeSheet
      open={effectiveOpen}
      onOpenChange={onOpenChange}
      targetName={locationName}
      onSnooze={handleSnooze}
      isPending={createSnooze.isPending}
      onLift={handleLift}
      isLiftPending={deleteSnooze.isPending}
      activeSnooze={isSnoozed ? activeSnooze : null}
    />
  );
};
